if (typeof window !== "undefined") {
  try {
    var WebFont = require("webfontloader");
    WebFont.load({
      google: {
        families: ["Montserrat:300,400,500,700", "sans-serif"]
      }
    });
  } catch (error) {
    // Fallback: fonts will still work via CSS, just without WebFont optimization
    console.warn("WebFont loader failed to initialize:", error);
  }
}
var PlayfairDisplay = '"Playfair Display", serif';
var Montserrat = '"Montserrat", sans-serif';
var ProximaNova = '"proxima-nova", sans-serif';

export { Montserrat, PlayfairDisplay, ProximaNova };
